<template>
	<div>
		<div class="main-header">
			<div class="container">
				<h2 class="main-header-text">EKYC Customer Bank Details</h2>
			</div>
		</div>
		<!-- eo main header -->


		<div class="main-section mgt-40">
			<div class="container">

				<div class="main-card">
					<img src="/static/img/icons/arrow-down-indicator-red.png" alt="" class="top-indicator" />
					<div class="main-card-header">
						<p>Dear Valued customer,
To continue, please provide us with your bank account details
as a compliance procedure</p>
					</div>
					<div class="row">
						<div class="col-lg-8">
							<form @submit.prevent="onSubmit" novalidate="" autocomplete="off">
								<div class="form-card">
									<div class="form-card-header">
										<h3>Bank Details</h3>
									</div>

									<div class="form-card-forms">

										<div class="row">

											<div class="col-lg-6">
												<div class="form-group">
													<label for="">
														Bank Name<span class="required">*</span>
													</label>
													<kendo-dropdownlist v-if="BankList != null" name='BankId' id='BankId' class="form-control" :class="{'input': true, 'is-danger': errors.has('BankId') }"
													 v-validate="'required'" v-model="vModel.BankId" :data-text-field="'Name'" :data-value-field="'Id'"
													 data-vv-as='Bank' :option-label="'Please Select Bank'" :auto-bind="true" :data-source="BankList"
													 :data-value-primitive="true" @select="onSelect" @change="onChange">
													</kendo-dropdownlist>

													<div v-show="errors.has('BankId')" class="help is-danger">{{ errors.first('BankId') }}</div>
												</div>
											</div>

										</div>

										<div class="row">

											<div class="col-lg-6">
												<div class="form-group">
													<label for="">
														Bank Account No<span class="required">*</span>
													</label>
													<input type="text" class="form-control text-uppercase" name="AccountNumber" autocomplete="off" v-model="vModel.AccountNumber"
													 data-vv-as='Account Number' v-validate="required" :class="{'input': true, 'is-danger': errors.has('AccountNumber') }" v-only-uppercase>
													<div v-show="errors.has('AccountNumber')" class="help is-danger">
														{{ errors.first('AccountNumber') }}
													</div>
												</div>
											</div>

										</div>
										<div class="row">
											<div class="notice-panel">
													<div class="right-panel">
														<div class="pl-3">
															<div class="round">
																<input name="EkycBankDetails" id="EkycBankDetails" v-validate="'required'"
																 type="checkbox" />
																<label for="EkycBankDetails"></label>
																<span class="pl-4">
																	I agree that the banking details provided by me above is true and in order
																</span>
															</div>
															<div class="help is-danger" v-show="errors.has('EkycBankDetails')">Please agree to terms and
															conditions to continue</div>
														</div>
														<!-- <p class="mt-2">
															By clicking confirm payment below, I confirm that all the details above are correct and in order.
															<br />
														</p> -->
													</div>
												</div>
										</div>

									</div>
									<!-- eo form card forms -->
								</div>
								<!-- eo form card -->

								<div class="submit-option">
									<div class="left-option">
										<button class="btn submit-lefticon-btn" type="button" @click="onLogout">
											<span class="left-icon">
												<i class="fas fa-angle-left"></i>
											</span>
											<span class="btn-content">Logout</span>
										</button>
									</div>

									<div class="right-option">
										<button class="btn submit-lefticon-btn">
											<span class="left-icon">
												<i class="fas fa-check"></i>
											</span>
											<span class="btn-content">Save</span>
										</button>
									</div>
								</div>
							</form>
						</div>
						<!-- eo col-8 -->

						<div class="col-lg-4">
							<UserDetailSection />
						</div>
					</div>
					<!-- eo row -->

				</div>
				<!-- eo main card -->

			</div>
			<!-- eo container -->
		</div>
		<!-- eo main section -->
	</div>

</template>
<script>
	import Base from "../../shared/Base.vue";
	import CommonService from "../../services/common";
	import UserDetailSection from '../../shared/UserDetailSection.vue'

	import ListService from "../../services/list";

	export default {
		name: "ChangePassword",
		extends: Base,
		components: {UserDetailSection },
		beforeRouteEnter(to, from, next) {
			console.log('ekyccdetail')
			var promises = [];
			promises.push(ListService.get("list/getallrefundbank"));
			Promise.all(promises).then(response => {
				next(p => {
					p.BankList = response[0].body;
				});
			});

		},
		methods: {
			onSubmit() {
				var self = this;
				if (self.isProcessing) return;

				self.$validator.validateAll().then(result => {
					if (result) {
						var url = 'account/bankaccountdetail/update';
						self.isProcessing = true;
						self.$http.post(url, self.vModel).then(
							response => {

								self.$toastr("success", "Updated successfully");
								self.isProcessing = false;
								CommonService.setStorage("IsRequiredEkycBankDetail", "false");
								setTimeout(function() {
									self.$router.push("/dashboard");
								}, 1000);
							},
							error => {
								self.isProcessing = false;
							}
						);
					}
				});
			},
			onSelect(e){
				if(this.vModel.BankId==e.dataItem.Id){
					return false;
				}
				// if(e.dataItem.Id){
				// 	this.RangeFrom=e.dataItem.RangeFrom;
				// 	this.RangeTo=e.dataItem.RangeTo
				// }else{
				// 	this.RangeFrom=0;
				// 	this.RangeTo=0;
				// }
				if(e.dataItem.RangeFrom&&e.dataItem.RangeTo){
					this.required=`required|min:${e.dataItem.RangeFrom}|max:${e.dataItem.RangeTo}`;
				}else{
					this.required='required';
				}



			},
			onChange(e){
			},
			onLogout(){
				CommonService.logOut();
			},
		},
		data() {
			return {
				vModel: {
					BankId: null,
					AccountNumber: null

				},
				BankList: null,
				RangeFrom:null,
				RangeTo:null,
				required:'required',
			};
		}
	};
</script>
